import { render, staticRenderFns } from "./freshgraduate.vue?vue&type=template&id=11c3bb7f&scoped=true"
import script from "./freshgraduate.vue?vue&type=script&lang=js"
export * from "./freshgraduate.vue?vue&type=script&lang=js"
import style0 from "./freshgraduate.vue?vue&type=style&index=0&id=11c3bb7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c3bb7f",
  null
  
)

export default component.exports